import { IAnalyticsSummary } from "../../../types/types";
import { parseApiResponse } from "../../../services/utils/apiError";

const api = import.meta.env.VITE_API_URL;

export const fetchAnalyticsSummary = async (sinceHours = 24): Promise<IAnalyticsSummary> => {
  const response = await fetch(`${api}/analytics/summary?since_hours=${String(sinceHours)}`, {
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  const data = await parseApiResponse<IAnalyticsSummary>(response);
  return data ?? { totalViews: 0, totalUniqueVisitors: 0, daily: [], pages: [], transitions: [] };
};
